import React, { useState } from "react";
import ReactDatatable from "@mkikets/react-datatable";
import { useGetCryptocurrencyQuery, useChangeCryptoStatusMutation } from "../../../redux/cryptocurrencyApi";
import { useGetNetworkQuery } from "../../../redux/networkApi";
import { Button } from "react-bootstrap";
import AddCryptocurrency from "../../partial/AddCryptocurrency";
import EditCryptocurrency from "../../partial/EditCryptocurrency";
import ViewCryptocurrency from "../../partial/ViewCryptocurrency";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from 'react-toastify';

import { useTranslation } from "react-i18next";

function Cryptocurrencies() {
    const { t } = useTranslation();
    const { data: apiResponse } = useGetCryptocurrencyQuery();
    const { data: networkResponse } = useGetNetworkQuery();

    const users = apiResponse?.data || [];
    const networks = networkResponse?.data || [];

    // Edit Modal State
    const [showEdit, setShowEdit] = useState(false);
    const [editData, setEditData] = useState({});

    const handleEdit = (cryptocurrency) => {
        setEditData(cryptocurrency);
        setShowEdit(true);
    };

    // View Modal State
    const [showView, setShowView] = useState(false);
    const [viewData, setViewData] = useState({});

    const handleView = (cryptocurrency) => {
        setViewData(cryptocurrency);
        setShowView(true);
    };

    // Add Modal State
    const [showAdd, setShowAdd] = useState(false);

    const [changeCryptoStatus] = useChangeCryptoStatusMutation();

    const handleStatusChange = (record) => {
        const message = record.crypto_status === 'active' 
            ? (t('change_status_inactive_msg') || "Do you want to change status as inactive")
            : (t('change_status_active_msg') || "Do you want to change status as active");
        
        confirmAlert({
            title: t('confirm_to_submit') || 'Confirm to submit',
            message: message,
            buttons: [
                {
                    label: t('yes') || 'Yes',
                    onClick: async () => {
                        try {
                            const res = await changeCryptoStatus({ id: record.id }).unwrap();
                            if (res.status) {
                                toast.success(t(res.message) || res.message);
                            } else {
                                toast.error(t(res.message) || res.message);
                            }
                        } catch (err) {
                            toast.error(t('error_changing_status') || 'Error changing status');
                        }
                    }
                },
                {
                    label: t('no') || 'No',
                    onClick: () => {}
                }
            ]
        });
    };


    const columns = [
        {
            key: "srno.",
            text: t('sr_no'),
            className: "sr_no.",
            align: "left",
            sortable: true,
            cell: (row, index) => index + 1,
        },
        {
            key: "coin_name",
            text: t('name'),
            className: "name",
            align: "left",
            sortable: true,
            cell: (record) => {
                return <><img style={{ width: "20px", height: "20px" }} className="img-fluid" src={record.logo_url} alt="" />{"  "}{record.coin_name}</>;
            },
        },
        {
            key: "coin_symbol",
            text: t('symbol'),
            className: "name",
            align: "left",
            sortable: true,
        },
        {
            key: "symbol",
            text: t('select_network'),
            className: "name",
            align: "left",
            sortable: true,
        },
        {
            key: "usd_price",
            text: t('usd_price'),
            className: "usd_price",
            align: "left",
            sortable: true,
        },
        {
            key: "is_token",
            text: t('is_token'),
            className: "is_token",
            align: "left",
            sortable: true,
        },
        {
            key: "wallet_type",
            text: t('wallet_type'),
            className: "wallet_type",
            align: "left",
            sortable: true,
        },
        {
            key: "transfer_fee_status",
            text: t('transfer_fee_status'),
            className: "transfer_fee_status",
            align: "left",
            sortable: true,
        },
        {
            key: "is_swapable",
            text: t('is_swapable'),
            className: "is_swapable",
            align: "left",
            sortable: true,
        },
        {
            key: "crypto_status",
            text: t('status') || "Status",
            className: "crypto_status",
            align: "left",
            sortable: true,
            cell: (record) => {
                return (
                    <span 
                        className={`badge ${record.crypto_status === 'active' ? 'bg-success' : 'bg-danger'}`}
                        style={{ cursor: 'pointer' }} 
                        onClick={() => handleStatusChange(record)}
                        title={t('click_to_change')}
                    >
                        {record.crypto_status === 'active' ? (t('active') || "Active") : (record.crypto_status === 'inactive' ? (t('inactive') || "Inactive") : record.crypto_status)}
                    </span>
                );
            },
        },
        {
            key: "action",
            text: t('actions'),
            className: "Action d-flex",
            align: "left",
            sortable: true,
            cell: (record) => {
                return (
                    <>
                        <Button variant="primary" size="sm" className="me-1" onClick={() => handleView(record)}>
                            {t('view')}
                        </Button>
                        <Button variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                            {t('edit')}
                        </Button>
                        {/* {record.is_token === "yes" && (
                            <Button variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                                {t('edit')}
                            </Button>
                        )} */}
                        {/* {record.is_token === "no" && (
                            <Button disabled variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                                {t('no_edit')}
                            </Button>
                        )} */}
                    </>
                );
            },
        },
    ];

    const config = {
        page_size: 5,
        length_menu: [5, 10, 20, 50],
        filename: "Fund Request List",
        no_data_text: t('no_record_found'),
        button: {
            // print: true,
            // csv: true,
        },
        language: {
            filter: t('search_in_records'),

            pagination: {
                first: t('first'),
                previous: t('previous'),
                next: t('next'),
                last: t('last'),
            },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
    };

    return (
        <section className="section dashboard">
            <div className="pagetitle d-flex align-items-center justify-content-between mb-4">
                <h1>{t('cryptocurrencies')}</h1>
                <Button variant="primary" onClick={() => setShowAdd(true)}>
                    {t('add_new_cryptocurrency')}
                </Button>
            </div>

            <div className="card">
                <div className="card-body pt-4">
                    <ReactDatatable
                        key={`datatable-aa`}
                        config={config}
                        records={users}
                        columns={columns}
                        dynamic={false}

                    />

                </div>
            </div>

            <EditCryptocurrency
                show={showEdit}
                onHide={() => setShowEdit(false)}
                cryptocurrency={editData}
                users={users}
            />

            <ViewCryptocurrency
                show={showView}
                onHide={() => setShowView(false)}
                viewData={viewData}
            />

            <AddCryptocurrency
                show={showAdd}
                onHide={() => setShowAdd(false)}
                networks={networks}
                users={users}
            />

        </section>
    );
}

export default Cryptocurrencies;
